import { Stack, TextField, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import { _ } from '/@/locale';
import { ITEM_TYPE_LABELS, type ShareItemPopupProps } from '..';

function EmailInputStep({
    emailInput,
    setEmailInput,
    itemType,
}: {
    emailInput: string | undefined;
    setEmailInput: (email: string) => void;
    itemType: ShareItemPopupProps['itemType'];
}) {
    const itemLabel = ITEM_TYPE_LABELS[itemType];
    return (
        <Stack spacing={3}>
            <Typography variant='body1' color='primary'>
                {_('{{itemLabel}} se enviará por correo electrónico al destinatario que indiques.', {
                    itemLabel: capitalize(itemLabel.gender),
                })}
            </Typography>
            <TextField
                value={emailInput || ''}
                onChange={(e) => setEmailInput(e.target.value)}
                label={_('Email')}
                variant='outlined'
                fullWidth
                data-testid='share-item-popup-email-input'
            />
        </Stack>
    );
}

export default EmailInputStep;
